const DEFAULT_TOUR = '/tour/nutrition-monthly-start';

export default function ({ redirect, route }) {
  if (route.path === '/tour') {
    return redirect(DEFAULT_TOUR);
  }
}
